/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { BaseAlertCardTaskFragmentDoc } from '../../../../alert-cards-common/src/lib/BaseAlertCard/BaseAlertCard.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { DefaultActionsOpenAlertFragmentDoc } from '../components/DefaultActionsOpenAlert/defaultActionsOpenAlert.hook'
import { MarkAsResolvedButtonAlertFragmentDoc } from '../components/MarkAsResolvedButton/markAsResolvedButton.hook'
import { MetaPhoneDriverEmployeeFragmentDoc } from '../components/MetaPhoneDriver/metaPhoneDriver.hook'
import { DefaultAlertCardDataAlertFragmentDoc } from '../hook/useDefaultAlertCardData/useDefaultAlertCardData.hook'
export type DriverHasNotShownUpYetAlertCardAlertFragment = {
  __typename: 'HubServiceNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  employee: {
    __typename?: 'Employee'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  shift: {
    __typename?: 'Shift'
    plannedFirstDeparture: string
    plannedLastArrival: string
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const DriverHasNotShownUpYetAlertCardAlertFragmentDoc = gql`
    fragment DriverHasNotShownUpYetAlertCardAlert on HubServiceNotification {
  id
  status
  employee {
    ...MetaPhoneDriverEmployee
  }
  shift {
    plannedFirstDeparture
    plannedLastArrival
  }
  ...DefaultActionsOpenAlert
  ...MarkAsResolvedButtonAlert
  ...DefaultAlertCardDataAlert
  ...BaseAlertCardTask
}
    ${MetaPhoneDriverEmployeeFragmentDoc}
${DefaultActionsOpenAlertFragmentDoc}
${MarkAsResolvedButtonAlertFragmentDoc}
${DefaultAlertCardDataAlertFragmentDoc}
${BaseAlertCardTaskFragmentDoc}`
